export default __webpack_public_path__ + "static/media/pokedex.2800773d.png";